import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Trophy, Target, Users, Zap } from 'lucide-react';
const benefits = [{
  icon: Trophy,
  title: 'Proven Track Record',
  description: 'We have helped hundreds of UK businesses achieve #1 rankings and multiply their revenue.'
}, {
  icon: Target,
  title: 'Data-Driven Strategy',
  description: 'No guesswork. We use advanced analytics and market data to make informed decisions for your growth.'
}, {
  icon: Users,
  title: 'Dedicated UK Team',
  description: 'Work with local experts who understand the UK market nuances and consumer behavior.'
}, {
  icon: Zap,
  title: 'Fast Results',
  description: 'Our agile methodologies ensure you start seeing improvements in traffic and leads quicker.'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-20 bg-white" data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-128">
          <div data-id="element-129">
            <SectionHeading title="Why Partner With Smart Market Digital?" subtitle="The Smart Choice" alignment="left" data-id="element-130" />
            <p className="text-lg text-slate-600 mb-8" data-id="element-131">
              In a crowded digital landscape, you need a partner who cuts
              through the noise. We don't just deliver traffic; we deliver
              revenue-generating leads and sustainable growth for your business.
            </p>

            <div className="space-y-8" data-id="element-132">
              {benefits.map((benefit, index) => <div key={index} className="flex gap-4" data-id="element-133">
                  <div className="flex-shrink-0" data-id="element-134">
                    <div className="w-12 h-12 bg-slate-900 rounded-full flex items-center justify-center" data-id="element-135">
                      <benefit.icon className="w-6 h-6 text-green-400" data-id="element-136" />
                    </div>
                  </div>
                  <div data-id="element-137">
                    <h4 className="text-lg font-bold text-slate-900 mb-1" data-id="element-138">
                      {benefit.title}
                    </h4>
                    <p className="text-slate-600" data-id="element-139">{benefit.description}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-140">
            <div className="absolute inset-0 bg-green-100 rounded-3xl transform rotate-3" data-id="element-141"></div>
            <div className="relative bg-slate-900 rounded-3xl p-8 md:p-12 shadow-2xl text-white" data-id="element-142">
              <h3 className="text-2xl font-bold mb-6" data-id="element-143">
                Ready to dominate your market?
              </h3>
              <p className="text-slate-300 mb-8" data-id="element-144">
                Get a free comprehensive SEO audit and digital strategy
                proposal. No obligations, just value.
              </p>
              <div className="space-y-4" data-id="element-145">
                <div className="flex items-center gap-3 text-slate-300" data-id="element-146">
                  <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-147"></div>
                  <span data-id="element-148">Competitor Analysis</span>
                </div>
                <div className="flex items-center gap-3 text-slate-300" data-id="element-149">
                  <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-150"></div>
                  <span data-id="element-151">Keyword Opportunity Report</span>
                </div>
                <div className="flex items-center gap-3 text-slate-300" data-id="element-152">
                  <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-153"></div>
                  <span data-id="element-154">Technical Site Health Check</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}